<template>
  <b-form @submit.prevent="alterarSenha" class="container">
    <b-form-group id="input-group-password-old" label="Senha Atual:" label-for="input-password-old">
      <b-form-input
        id="input-password-old"
        v-model="oldPassword"
        type="password"
        required
        placeholder="Digite sua senha atual"
      ></b-form-input>
    </b-form-group>
    <b-form-group id="input-group-password-new-one" label="Nova Senha:" label-for="input-password-new-one">
      <b-form-input
        id="input-password-new-one"
        v-model="newPassword"
        type="password"
        required
        placeholder="Digite sua nova senha"
      ></b-form-input>
    </b-form-group>
    <b-form-group id="input-group-password-two" label="Confirme Sua Nova Senha:" label-for="input-password-new-two">
      <b-form-input
        id="input-password-new-two"
        v-model="confirmNewPassword"
        type="password"
        required
        placeholder="Digite sua nova senha novamente"
      ></b-form-input>
    </b-form-group>
    <b-alert v-model="successState" variant="success" dismissible>Senha Alterada com Sucesso</b-alert>
    <b-alert v-model="errorState" variant="danger" dismissible>Não foi possível alterar a senha</b-alert>
    <b-alert v-model="confirmNotMatch" variant="danger" dismissible>A confirmação da senha não corresponde</b-alert>
    <b-button type="submit" variant="primary" class="mr-2 mb-2">
      <b-spinner v-if="loading" small class="mr-2"></b-spinner>Salvar
    </b-button>
  </b-form>
</template>

<script>
export default {
  name: "ChangePassword",
  data() {
    return {
      oldPassword: "",
      newPassword: "",
      confirmNewPassword: "",
      confirmNotMatch: false,
      loading: false,
      errorState: false,
      successState: false
    };
  },
  methods:{
      alterarSenha(){
          this.confirmNotMatch = false;
          this.loading = false;
          this.errorState = false;
          this.successState = false;
          if (this.newPassword != this.confirmNewPassword){
              this.confirmNotMatch = true;
              return;
          }
          this.loading = true;
          this.$store.dispatch("changePassword", {
              oldPassword: this.oldPassword,
              newPassword: this.newPassword,
              confirmNewPassword: this.confirmNewPassword
          }).then(() => {
              this.successState = true;
              this.loading = false;
          }).catch((error) => {
              this.errorState = true;
              this.loading = false;
              console.log(error);
          })
      }
  }
};
</script>

<style>
</style>